import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { ILinkedScriptExecuteBehavior, ILinkedObjectSpecifiable } from "../../../../documaker/domain/format/objects";
import { instanceOfIPresentableLinkedObjectIdentifier } from "./IPresentableLinkedObjectIdentifier";

export interface IScriptExecuteBehaviorPropertyEditable {
  scriptExecuteBehavior(): IPropertyEditable<ILinkedScriptExecuteBehavior>;
  toLinkedObjectIdentifier(): ILinkedObjectSpecifiable;
}

export function instanceOfIScriptExecuteBehaviorPropertyEditable(instance: any): instance is IScriptExecuteBehaviorPropertyEditable {
  return instance
      && instance.scriptExecuteBehavior
      && instanceOfIPropertyEditable<ILinkedScriptExecuteBehavior>(instance.scriptExecuteBehavior())
      && instanceOfIPresentableLinkedObjectIdentifier(instance);
}
